module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Rickenbach_BL-91884e5ecf5e910411a266129e78aa83.svg";